import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.terms');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-terms',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminTermsComponent implements OnInit {
    // 서브탭: concepts | candidates
    public subtab: string = 'concepts';

    // ─── 개념 관리 ─────────────────
    public concepts: any[] = [];
    public conceptTotal: number = 0;
    public conceptPage: number = 1;
    public conceptSearch: any = { text: '', domain: '', status: 'active' };
    public selectedConcept: any = null;
    public showConceptModal: boolean = false;
    public conceptForm: any = { representative_name: '', domain: '', era: '', definition: '', source: '' };
    public isNewConcept: boolean = false;
    public newSynonym: any = { name: '', name_type: 'synonym', language: 'ko' };

    // ─── 후보 검수 ─────────────────
    public candidates: any[] = [];
    public candidateTotal: number = 0;
    public candidatePage: number = 1;
    public candidateSearch: any = { text: '', status: 'pending' };
    public selectedCandidate: any = null;
    public showCandidateModal: boolean = false;
    public reviewNote: string = '';
    public newConceptForm: any = { representative_name: '', domain: '', definition: '' };

    // 도메인 옵션
    public domains: string[] = ['고고', '미술', '보존', '건축', '안전방재'];
    public candidateStatuses: any[] = [
        { value: 'pending', label: '대기' },
        { value: 'approved', label: '승인' },
        { value: 'rejected', label: '반려' },
        { value: 'deferred', label: '보류' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadConcepts();
        await this.service.render();
    }

    public async switchTab(tab: string) {
        this.subtab = tab;
        if (tab === 'concepts') await this.loadConcepts();
        else await this.loadCandidates();
        await this.service.render();
    }

    // ─── 개념 CRUD ─────────────────

    public async loadConcepts(page: number = 1) {
        this.conceptPage = page;
        const { code, data } = await wiz.call("concept_list", {
            ...this.conceptSearch,
            page: this.conceptPage,
        });
        if (code === 200) {
            this.concepts = data.list || [];
            this.conceptTotal = data.total || 0;
        }
        await this.service.render();
    }

    public get conceptTotalPages(): number {
        return Math.max(1, Math.ceil(this.conceptTotal / 20));
    }

    public async openConceptDetail(concept: any) {
        const { code, data } = await wiz.call("concept_get", { id: concept.id });
        if (code === 200) {
            this.selectedConcept = data;
            this.showConceptModal = true;
            this.newSynonym = { name: '', name_type: 'synonym', language: 'ko' };
            await this.service.render();
        }
    }

    public openNewConcept() {
        this.isNewConcept = true;
        this.conceptForm = { representative_name: '', domain: '', era: '', definition: '', source: '' };
        this.showConceptModal = true;
    }

    public async saveConcept() {
        if (this.isNewConcept) {
            const { code } = await wiz.call("concept_create", this.conceptForm);
            if (code === 200) {
                this.showConceptModal = false;
                this.isNewConcept = false;
                await this.loadConcepts();
            }
        } else if (this.selectedConcept) {
            const { code } = await wiz.call("concept_update", {
                id: this.selectedConcept.id,
                ...this.conceptForm,
            });
            if (code === 200) {
                this.showConceptModal = false;
                await this.loadConcepts();
            }
        }
    }

    public startEditConcept() {
        if (!this.selectedConcept) return;
        this.isNewConcept = false;
        this.conceptForm = {
            representative_name: this.selectedConcept.representative_name,
            domain: this.selectedConcept.domain,
            era: this.selectedConcept.era || '',
            definition: this.selectedConcept.definition || '',
            source: this.selectedConcept.source || '',
        };
    }

    public async addSynonym() {
        if (!this.newSynonym.name || !this.selectedConcept) return;
        const { code } = await wiz.call("synonym_add", {
            concept_id: this.selectedConcept.id,
            ...this.newSynonym,
        });
        if (code === 200) {
            this.newSynonym = { name: '', name_type: 'synonym', language: 'ko' };
            await this.openConceptDetail(this.selectedConcept);
        }
    }

    public async removeSynonym(synId: number) {
        if (!confirm('이 동의어를 삭제하시겠습니까?')) return;
        const { code } = await wiz.call("synonym_remove", { id: synId });
        if (code === 200) {
            await this.openConceptDetail(this.selectedConcept);
        }
    }

    // ─── 후보 검수 ─────────────────

    public async loadCandidates(page: number = 1) {
        this.candidatePage = page;
        const { code, data } = await wiz.call("candidate_list", {
            ...this.candidateSearch,
            page: this.candidatePage,
        });
        if (code === 200) {
            this.candidates = data.list || [];
            this.candidateTotal = data.total || 0;
        }
        await this.service.render();
    }

    public get candidateTotalPages(): number {
        return Math.max(1, Math.ceil(this.candidateTotal / 20));
    }

    public async openCandidateDetail(candidate: any) {
        const { code, data } = await wiz.call("candidate_get", { id: candidate.id });
        if (code === 200) {
            this.selectedCandidate = data;
            this.showCandidateModal = true;
            this.reviewNote = '';
            this.newConceptForm = { representative_name: data.surface_form, domain: '', definition: '' };
            await this.service.render();
        }
    }

    public async reviewAction(action: string) {
        if (!this.selectedCandidate) return;
        const params: any = {
            id: this.selectedCandidate.id,
            action: action,
            note: this.reviewNote,
        };
        if (action === 'approve' && this.selectedCandidate.suggested_concept_id) {
            params.concept_id = this.selectedCandidate.suggested_concept_id;
        }
        if (action === 'new_concept') {
            params.concept_data = JSON.stringify(this.newConceptForm);
        }
        const { code } = await wiz.call("candidate_review", params);
        if (code === 200) {
            this.showCandidateModal = false;
            await this.loadCandidates();
        }
    }

    public closeModal() {
        this.showConceptModal = false;
        this.showCandidateModal = false;
        this.selectedConcept = null;
        this.selectedCandidate = null;
        this.isNewConcept = false;
    }
}

export default PortalNrichadminAdminTermsComponent;